import { useQueryClient } from '@tanstack/react-query';

import { Nullable } from 'shared_DEPRECATED/types';
import { LinkPreview } from 'types/common';

import { ChatMessageLinkPreviewUploaded } from 'features/chat/components/ChatMessages/LinkPreviewUploaded';

import { extractLinksFromString } from 'shared/utils/links';

type TChatMessageLinkPreviewUnuploaded = {
  text: string;
};

export const ChatMessageLinkPreviewUnuploaded = ({
  text,
}: TChatMessageLinkPreviewUnuploaded) => {
  const queryClient = useQueryClient();
  const url = extractLinksFromString(text)[0];

  if (url) {
    const linkPreview = queryClient.getQueryData<Nullable<LinkPreview>>([
      'link-preview',
      url,
    ]);

    if (linkPreview?.url) {
      return (
        <ChatMessageLinkPreviewUploaded
          title={linkPreview.title}
          description={linkPreview.description}
          image={linkPreview.imageMetadata.url}
          url={linkPreview.url}
        />
      );
    }
  }

  return null;
};
